/**
 * The Wix Customer Care hand-off — the ONE support route this product owns.
 *
 * It is the same landing node the assistant's `EscalateToCustomerCare` tool hands out
 * (`orion-harness-poc/src/services/customer-care/customer-care-client.ts`), provisioned for Symphony by
 * Customer Care. The `customer-support` skill is explicit that this is the only support path: a support
 * mailbox or a bare help-centre link is what it forbids, because an invented `support@` once bounced a
 * real user. `SUPPORT_URL` (`support.wix.com`, the Settings "Contact us" row) is the HELP CENTRE — it
 * answers questions, it does not pick up a stuck account.
 *
 * The referral tag is the only thing that varies per origin, so a hand-off that started on a blocked
 * screen is distinguishable in Care's analytics from one the assistant made.
 *
 * ⚠️ Nothing identifying may be appended. A browser URL is broadcast to every analytics tag on the page
 * it opens — the same reason the onboarding pages keep the phone number and the verificationId off their
 * own URLs (see `lib/use-code-verification.ts`). Care resolves who the person is from their Wix session.
 *
 * Kept 1:1 with the native twins (`SupportHandoff` on iOS and Android).
 */
const LANDING_NODE_ID = '937a9206-ae79-4fb3-88e7-78610746bcf6';

export function customerCareUrl(referral: string): string {
  return `https://www.wix.com/contact?nodeId=${LANDING_NODE_ID}&referral=${encodeURIComponent(referral)}`;
}

/** The phone-in-use (recipient conflict) dead end on the code step. */
export const PHONE_CONFLICT_CARE_URL = customerCareUrl('Symphony_app_recipient_conflict');
